import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { useEpic } from "../../../../../reactQuery/epics";
import { searchCard } from "../../../../../redux/EpicSearchSlice";
import { isAdmin } from "../../../../../utils/constants";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import EditMIlestone from "../../../../../components/Milestone/EditMilestone";
import apicIcon from "../../../../../styles/svg/updt_milestone.svg";
import DarkIcon from "../../../../../styles/svg/milestone-dark.svg";
import MobileEpicView from "./MobileEpicView";
import DesktopEpicView from "./DesktopEpicView";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";
import { getResponseData } from "../../../../../reactQuery/response";
import {
  getBoardNameTitle,
  getEpicPermissions,
  groupEpics,
} from "./epicButtonUtils";

const EpicButton = ({
  boardNameDetails,
  showNoMile = true,
  isTab = false,
  selectedMilestone,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [NoMilestone, setMilestone] = useCustomSearchParams("noMilestone");
  const [epic, setEpic] = useState(
    searchParams.get("milestone")
      ? searchParams
          .get("milestone")
          .split(",")
          .filter((el) => el)
          .map((el) => el * 1)
      : []
  );
  const [editMileStonePop, setEditMileStonePop] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [showEditArea, setShowEditArea] = useState(false);

  const dispatch = useDispatch();
  const isMobile = useResponsive("down", "md");
  const { id } = useBoardIdByKey();
  const epicUrl = searchParams.get("milestone");
  const noMileStoneSearch = searchParams.get("noMilestone");
  const isShowGanttchart = searchParams.get("GantChart");
  const boardNameTitle = useMemo(
    () => getBoardNameTitle(boardNameDetails),
    [boardNameDetails]
  );
  const permissions = useMemo(
    () => getEpicPermissions(boardNameDetails, isAdmin),
    [boardNameDetails]
  );

  const { epics } = useEpic(id);
  const names = getResponseData(epics, []);
  const open = Boolean(anchorEl);

  // Callbacks
  const handleClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const updateSearchParams = useCallback((key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(key, value);
    setSearchParams(newSearchParams);
  }, [searchParams, setSearchParams]);

  const handleCheckboxChange = useCallback((id) => {
    searchParams.delete("noMilestone");
    setEpic((prevEpic) => {
      if (prevEpic.includes(id)) {
        updateSearchParams(
          "milestone",
          prevEpic.filter((n) => n !== id)
        );
        searchParams.delete("milestone");
        return prevEpic.filter((n) => n !== id);
      } else {
        updateSearchParams("milestone", [id]);
        return [id];
      }
    });
  }, [searchParams, updateSearchParams]);

  const handleNoMilestone = useCallback(() => {
    if (isShowGanttchart === "true") {
      updateSearchParams("GantChart", "false");
    }
    if (noMileStoneSearch === "true") {
      updateSearchParams("noMilestone", "false");
    } else {
      searchParams.set("milestone", "");
      updateSearchParams("noMilestone", "true");
    }
  }, [noMileStoneSearch, searchParams, updateSearchParams]);

  const showEditButton = useCallback((epic_id) => {
    setHoveredIndex(epic_id);
  }, []);

  const handleEditFieldClose = useCallback(() => {
    setShowEditArea(false);
    setHoveredIndex(null);
  }, []);

  useEffect(() => {
    const data = searchParams
      .get("milestone")
      ?.split(",")
      ?.filter((el) => el)
      ?.map((el) => el * 1);
    dispatch(searchCard(data || []));
    setEpic(data || []);
  }, [epicUrl]);

  const sortedNames = useMemo(() => groupEpics(names), [names]);
  
   // Memoized props object
   const commonProps = useMemo(() => ({
    isAdmin,
    boardNameDetails,
    showNoMile,
    noMileStoneSearch,
    handleNoMilestone,
    unCompletedMileStones: sortedNames.unCompletedMileStones,
    completedMileStones: sortedNames.completedMileStones,
    epic,
    showEditArea,
    hoveredIndex,
    boardNameTitle,
    showEditButton,
    handleEditFieldClose,
    handleCheckboxChange,
    names,
    permissions,
  }), [
    boardNameDetails,
    showNoMile,
    noMileStoneSearch,
    handleNoMilestone,
    sortedNames,
    epic,
    showEditArea,
    hoveredIndex,
    boardNameTitle,
    showEditButton,
    handleEditFieldClose,
    handleCheckboxChange,
    names,
    permissions,
  ]);

  return (
    <>
      {/* {isMobile ? (
        <MobileEpicView {...commonProps} />
      ) : ( */}
        <DesktopEpicView
          {...commonProps}
          isTab={isTab}
          selectedMilestone={selectedMilestone}
          NoMilestone={NoMilestone}
          anchorEl={anchorEl}
          open={open}
          handleClick={handleClick}
          handleClose={handleClose}
          DarkIcon={DarkIcon}
          apicIcon={apicIcon}
        />
      {/* )} */}
      {epicUrl && (
        <EditMIlestone
          open={editMileStonePop}
          handleClose={() => setEditMileStonePop(false)}
          setShowEditArea={setShowEditArea}
        />
      )}
    </>
  );
};

export default EpicButton;
